import { forwardRef } from "react";
import { HomepageBlock2 } from "../../Homepage/HomepageBlock2/HomepageBlock2";
import type { HomepageBlock2Props } from "../../Homepage/HomepageBlock2/HomepageBlock2";

export const AboutUsBlock2 = forwardRef<HTMLDivElement, HomepageBlock2Props>(
  ({ ...rest }, ref) => <HomepageBlock2 ref={ref} {...rest} />,
);

AboutUsBlock2.displayName = "AboutUsBlock2";
